import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import useStore from "../store/useStore";

export default function MisimClientes() {
  const { misimClientes, fetchMisimClientes } = useStore();
  const local = "https://api.institucional.global.sidom.io";

  useEffect(() => {
    fetchMisimClientes();
  }, [fetchMisimClientes]);

  const chunkArray = (arr, chunkCount) => {
    const chunks = Array.from({ length: chunkCount }, () => []);
    arr.forEach((item, i) => {
      chunks[i % chunkCount].push(item);
    });
    return chunks;
  };

  const sliders = misimClientes ? chunkArray(misimClientes, 3) : [];

  return (
    <div className="w-full bg-sidom-blue flex flex-col items-center justify-center">
      <div
        data-aos="fade-up"
        data-aos-delay="100"
        className="container mt-[100px]"
      >
        <h2 className="text-sidom-orange text-4xl md:text-5xl font-extrabold w-full text-left mb-[60px]">
          Clientes
        </h2>
      </div>

      <div className="mb-[100px] w-full flex flex-col gap-12">
        {sliders.map((grupo, idx) => (
          <div className="container" key={`slider-${idx}`}>
            <Swiper
              spaceBetween={10}
              slidesPerView={3}
              loop={true}
              speed={7000}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                reverseDirection: idx % 2 === 0,
              }}
              modules={[Autoplay]}
              breakpoints={{
                0: { slidesPerView: 1, spaceBetween: 10 },
                400: { slidesPerView: 2, spaceBetween: 10 },
                640: { slidesPerView: 4, spaceBetween: 10 },
                1024: { slidesPerView: 8, spaceBetween: 10 },
              }}
              className="w-full"
            >
              {[...grupo, ...grupo, ...grupo].map((cliente, i) => {
                const imagen = cliente.img?.[0];
                if (!imagen) return null;

                const imageUrl = `${local}${
                  imagen.formats?.thumbnail?.url || imagen.url
                }`;
                const altText = imagen.alternativeText || "Cliente";

                return (
                  <SwiperSlide
                    key={`${cliente.id}-${i}-${idx}`}
                    className="flex items-center justify-center"
                  >
                    <img
                      src={imageUrl}
                      alt={altText}
                      className="h-20 md:h-24 object-contain transition duration-300 mx-auto rounded-lg shadow"
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        ))}
      </div>
    </div>
  );
}
